import { useEffect } from "react"
import { useExchangeOAuthToken } from 'services/auth/mutations';

const OAuthWrapper = (props: any) => {
  const {
    execute: exchangeOAuthToken
  } = useExchangeOAuthToken()

  const oAuthToken = new URLSearchParams(window.location.search).get("oauth")

  useEffect(() => {
    if (oAuthToken) {
      exchangeOAuthToken({
        token: oAuthToken
      })
        .then(({ data }) => {
          if (data) {
            if (localStorage.getItem('token')) {
              localStorage.removeItem('token');
            }

            setTimeout(() => {
              const token = data.exchangeOAuthToken;
              localStorage.setItem('token', token);
              const isNew = new URLSearchParams(window.location.search).get("isNew");
  
              if (!isNew) {
                localStorage.setItem('fromOAuth', 'true');
              } else {
                localStorage.removeItem('fromOAuth');
              }
  
              window.dispatchEvent(new Event('storage'));

              setTimeout(() => {
                const url = new URL(window.location.href);
                const loanId = url.searchParams.get("loanId");
                
                url.searchParams.delete("oauth");
                url.searchParams.delete("loanId");
                
                url.pathname = `/home/${loanId}`;
                window.history.replaceState({}, document.title, url.toString());
                window.location.reload();
              })
            })
          }
        })
    }
  }, [oAuthToken])

  return (props.children)
}

export default OAuthWrapper 